export default "__VITE_ASSET__RXhFBywc__"